import { Children, cloneElement, CSSProperties, isValidElement, ReactNode } from "react";

export interface RadioInputGroupProps {
  name: string;
  label: string;
  children: ReactNode;
  handleChange: (value: string) => void;
}

export function RadioInputGroup({ label, name, handleChange, children }: RadioInputGroupProps) {
  return (
    <>
      <fieldset>
        <legend className="mb-4 font-semibold">{label}</legend>
        <div className="flex flex-col gap-2">
          {Children.map(children, (child, index) => {
            if (!isValidElement<RadioInputProps>(child)) {
              return child;
            }

            const radioInputElem: React.ReactElement<RadioInputProps> = child;
            const id = `${name}-option-${index}`;
            return cloneElement(radioInputElem, {
              id,
              name,
              handleChange,
            });
          })}
        </div>
      </fieldset>
    </>
  );
}

export interface RadioInputProps {
  id?: string;
  name?: string;
  value: string;
  checked: boolean;
  disabled?: boolean;
  children: ReactNode;
  keyName?: string;
  className?: string;
  style?: CSSProperties;
  handleChange?: (value: string) => void;
}

export function RadioInput({
  id,
  name,
  value,
  checked,
  children,
  className,
  style = {},
  disabled = false,
  handleChange = () => {},
}: RadioInputProps) {
  return (
    <div className="flex items-start">
      <input
        type="radio"
        name={name}
        id={id}
        className={`mr-2 mt-1`}
        style={{ filter: "grayscale(100%)" }}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={() => handleChange(value)}
      />
      <label htmlFor={id} className={`block text-red-400 ${className}`} style={style}>
        {children}
      </label>
    </div>
  );
}
